// DeleteConfirmationModal.jsx
// components/modals/DeleteConfirmationModal.jsx
import React from 'react';
import styles from '../components/ReservationTable.module.css'; // Adjust path as needed

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.modalCloseButton} onClick={onClose}>&times;</button>
        <h3 style={{ marginBottom: '20px', fontSize: '20px', fontWeight: '600', color: '#111827' }}>
          Confirm Deletion
        </h3>
        <p style={{ marginBottom: '20px', color: '#374151' }}>
          Are you sure you want to delete this booking? This action cannot be undone.
        </p>
        <div className={styles.modalButtonsContainer}>
          <button
            onClick={onClose}
            className={styles.modalCancelBtn}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={styles.modalDeleteBtn}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;